(() => {
  const root = document.querySelector('[data-velae-assistant]');

  if (!root || root.dataset.ready === 'true') return;

  root.dataset.ready = 'true';

  const toggle = root.querySelector('[data-assistant-toggle]');
  const panel = root.querySelector('[data-assistant-panel]');
  const close = root.querySelector('[data-assistant-close]');
  const messages = root.querySelector('[data-assistant-messages]');
  const form = root.querySelector('[data-assistant-form]');
  const input = root.querySelector('[data-assistant-input]');
  const sendButton = form.querySelector('[type="submit"]');
  const chipsContainer = root.querySelector('[data-assistant-chips]');
  const config = JSON.parse(root.querySelector('[data-assistant-config]').textContent);
  const externalWhatsAppWidgets = new Set();

  let catalogPromise = null;
  let smartChipsReady = false;
  let productContextShown = false;
  let collectionContextShown = false;
  let activeRequest = 0;
  let previousFocus = null;
  const storageKey = 'velae-eva-session-v1';
  let activeCriteria = {
    size: '',
    color: '',
    type: '',
    occasion: '',
    feel: '',
    budgetMax: '',
    budgetMin: '',
    query: '',
  };
  let conversationTurns = 0;
  const baseQuickPrompts = [
    { label: 'Para evento', value: 'evento elegante' },
    { label: 'Para diario', value: 'diario comodo' },
    { label: 'Bolsos', value: 'bolsos' },
    { label: 'Regalo', value: 'regalo versatil' },
  ];

  const colorGroups = {
    negro: ['negro', 'negra', 'negros', 'negras'],
    beige: ['beige', 'marfil', 'perla', 'nude'],
    blanco: ['blanco', 'blanca', 'blancos', 'blancas', 'marfil', 'perla'],
    cafe: ['cafe', 'caramelo', 'marron', 'chocolate', 'camel'],
    dorado: ['dorado', 'dorada', 'dorados', 'doradas', 'oro', 'bronce'],
    crema: ['crema', 'cream'],
    rosa: ['oro rosa', 'rosa', 'rosado', 'rosada', 'rosados', 'rosadas'],
    rojo: ['rojo', 'roja', 'vino'],
    azul: ['azul', 'celeste'],
    plateado: ['plateado', 'plateada', 'plata'],
    multicolor: ['multicolor'],
  };

  const typeGroups = {
    sandalias: ['sandalia', 'sandalias', 'alpargata', 'alpargatas', 'yute'],
    tacones: ['tacon', 'tacones', 'cuna', 'cunas', 'plataforma', 'alto'],
    botas: ['bota', 'botas', 'botin', 'botines'],
    tenis: ['tenis', 'sneaker', 'sneakers', 'slip', 'slip on'],
    oxford: ['oxford'],
    flats: ['flat', 'flats', 'balerina', 'balerinas', 'plano', 'planos'],
    bolsos: ['bolso', 'bolsos', 'cartera', 'carteras', 'crossbody', 'tote'],
    accesorios: ['accesorio', 'accesorios', 'billetera', 'billeteras', 'monedero', 'monederos'],
  };

  const occasionGroups = {
    oficina: ['oficina', 'trabajo', 'formal', 'elegante'],
    diario: ['diario', 'dia', 'caminar', 'comodo', 'comoda', 'casual'],
    fiesta: ['fiesta', 'noche', 'evento', 'salir', 'boda', 'graduacion'],
    verano: ['verano', 'playa', 'fresco', 'fresca'],
  };

  const feelGroups = {
    comodo: ['comodo', 'comoda', 'caminar', 'suave', 'descanso'],
    elegante: ['elegante', 'formal', 'sofisticado', 'sofisticada'],
    bajo: ['bajo', 'baja', 'tacon bajo'],
    alto: ['alto', 'alta', 'tacon alto'],
  };

  const advisorIntents = {
    recommendation: ['recomienda', 'recomendame', 'sugiere', 'sugerime', 'ayudame', 'elegir', 'ideal', 'mejor'],
    gift: ['regalo', 'regalar', 'cumpleanos', 'detalle'],
    compare: ['comparar', 'diferencia', 'cual es mejor', 'mejor opcion'],
    availability: ['disponible', 'hay', 'tienes', 'tenes', 'queda', 'stock'],
  };

  const accessoryWords = ['accesorio', 'billetera', 'biletera', 'cartera', 'bolso', 'monedero', 'crossbody', 'tote'];
  const shoeWords = [
    'zapato',
    'zapatos',
    'sandalia',
    'sandalias',
    'tacon',
    'tacones',
    'bota',
    'botas',
    'botin',
    'botines',
    'tenis',
    'sneaker',
    'slip',
    'alpargata',
    'oxford',
    'cuna',
    'plataforma',
  ];

  const searchStopWords = new Set(
    [
      'quiero',
      'busco',
      'buscar',
      'ver',
      'mostrar',
      'muestrame',
      'necesito',
      'tengo',
      'hay',
      'disponible',
      'disponibles',
      'talla',
      'numero',
      'color',
      'zapato',
      'zapatos',
      'calzado',
      'dama',
      'mujer',
      'para',
      'con',
      'los',
      'las',
      'una',
      'unos',
      'del',
      'que',
      'me',
      'eva',
      'algo',
      'opcion',
      'opciones',
      'ideal',
      'estilo',
      'recomienda',
      'recomendame',
      'sugiere',
      'sugerime',
      'menos',
      'maximo',
      'hasta',
      'barato',
      'barata',
      'economico',
      'economica',
      'presupuesto',
      'precio',
      'crc',
      'regalo',
      'regalar',
      'versatil',
      'versatiles',
    ].concat(
      Object.values(colorGroups).flatMap((terms) => terms.flatMap((term) => term.split(' '))),
      Object.values(typeGroups).flatMap((terms) => terms.flatMap((term) => term.split(' '))),
      Object.values(occasionGroups).flatMap((terms) => terms.flatMap((term) => term.split(' '))),
      Object.values(feelGroups).flatMap((terms) => terms.flatMap((term) => term.split(' ')))
    )
  );

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const matchesAny = (text, terms) => terms.some((term) => text.includes(term));

  const sizeGuideTable = [
    { cm: 22, size: 35 },
    { cm: 23, size: 36 },
    { cm: 24, size: 37 },
    { cm: 25, size: 38 },
    { cm: 26, size: 39 },
    { cm: 27, size: 40 },
  ];

  const getGuideEntryFromSize = (size) => sizeGuideTable.find((entry) => String(entry.size) === String(size));

  const getGuideSizeFromQuery = (rawText) => {
    const text = normalize(rawText);
    const sizePattern = '(35|36|37|38|39|40)';
    const sizeBeforeMeasure = text.match(
      new RegExp(`(?:talla|numero|calzo|calce|soy|uso|normalmente soy)[^\\d]{0,16}${sizePattern}\\b`)
    );
    const measureBeforeSize = text.match(
      new RegExp(`(?:cuanto|cuantos|cuanta|cuantas|cm|centimetro|centimetros|medir|mide|medida|pie|equivale)[^\\d]{0,28}${sizePattern}\\b`)
    );
    const sizeWithMeasureContext = text.match(
      new RegExp(`\\b${sizePattern}\\b(?=[^\\d]{0,36}(?:cuanto|cuantos|cm|centimetro|centimetros|medir|mide|medida|pie|equivale))`)
    );
    const match = sizeBeforeMeasure || measureBeforeSize || sizeWithMeasureContext;

    return match ? Number(match[1]) : null;
  };

  const getFootLengthCm = (rawText) => {
    const text = normalize(rawText).replace(/,/g, '.');
    const directMatch = text.match(/(\d{2}(?:\.\d{1,2})?)\s*(?:cm|cms|c\.m\.|centimetro|centimetros)\b/);
    const footMatch = text.match(/(?:pie|pies|planta|medida|mide|mido)[^\d]{0,18}(\d{2}(?:\.\d)?)/);
    const sizeQuestionMatch =
      matchesAny(text, ['talla', 'numero', 'calzo', 'calce']) &&
      text.match(/\b((?:1[5-9]|2[0-9]|3[0-4])(?:\.\d{1,2})?)\b/);
    const halfMatch = text.match(/\b(1[5-9]|2[0-9]|3[0-4])\s*(?:y\s*)?(?:medio|media)\b/);
    const bareMetricMatch = text.match(/^\s*((?:1[5-9]|2[0-9]|3[0-4])(?:\.\d{1,2})?)\s*(?:\?+|!+)?\s*$/);
    const value = halfMatch
      ? Number(halfMatch[1]) + 0.5
      : Number((directMatch || footMatch || sizeQuestionMatch || bareMetricMatch || [])[1]);

    return Number.isFinite(value) && value >= 15 && value <= 34 ? value : null;
  };

  const getSizeRecommendationFromCm = (measurement) => {
    if (!measurement) return null;

    const lower = [...sizeGuideTable].reverse().find((entry) => entry.cm <= measurement);
    const upper = sizeGuideTable.find((entry) => entry.cm >= measurement);

    if (!lower) {
      return { measurement, belowRange: true, nearestCm: sizeGuideTable[0].cm, nearestSize: sizeGuideTable[0].size };
    }

    if (!upper) {
      const last = sizeGuideTable[sizeGuideTable.length - 1];
      return { measurement, aboveRange: true, nearestCm: last.cm, nearestSize: last.size };
    }

    if (lower.cm === upper.cm) {
      return { measurement, size: lower.size, exact: true, nearestCm: lower.cm };
    }

    return {
      measurement,
      size: upper.size,
      lowerSize: lower.size,
      upperSize: upper.size,
      lowerCm: lower.cm,
      upperCm: upper.cm,
      between: true,
    };
  };

  const isSizeGuideQuery = (text) => {
    if (getFootLengthCm(text)) return true;

    const guideTerms = [
      'guia de talla',
      'guia de tallas',
      'guia tallas',
      'guia de tollas',
      'guia de taya',
      'guia de tayas',
      'guia de medida',
      'guia de medidas',
      'tabla de tallas',
      'tabla tallas',
      'tabla de medidas',
      'tabla medidas',
      'medir mi pie',
      'medir pie',
      'mido mi pie',
      'medirme el pie',
      'como mido mi pie',
      'cuanto debe medir mi pie',
      'cuanto mide mi pie',
      'cuanto tiene que medir mi pie',
      'cuantos centimetros debe medir',
      'cuantos cm debe medir',
      'a cuantos cm equivale',
      'a cuantos centimetros equivale',
      'medida del pie',
      'medidas del pie',
      'largo del pie',
      'ancho del pie',
      'plantilla del pie',
      'centimetro',
      'centimetros',
      'cm de pie',
      'pie en cm',
      'medida en cm',
      'medida en centimetros',
      'horma',
      'calce',
      'ajuste',
      'entre dos tallas',
      'entre tallas',
      'talla correcta',
      'numero correcto',
      'duda de talla',
      'dudas de talla',
      'duda por talla',
      'dudas por talla',
      'verificar mi talla',
      'revisar mi talla',
      'corroborar mi talla',
      'confirmar mi talla',
      'validar mi talla',
      'saber mi talla',
      'verificar talla',
      'revisar talla',
      'corroborar talla',
      'confirmar talla',
      'validar talla',
      'saber talla',
      'que talla soy',
      'cual talla soy',
      'cual es mi talla',
      'que talla me queda',
      'cual talla me queda',
      'que talla me recomiendas',
      'que talla debo pedir',
      'cual talla debo pedir',
      'que talla compro',
      'cual talla compro',
      'que numero soy',
      'cual numero soy',
      'cual es mi numero',
      'que numero me queda',
      'cual numero me queda',
      'que numero debo pedir',
      'como saber mi talla',
      'como verificar mi talla',
      'como revisar mi talla',
      'como corroborar mi talla',
      'como confirmar mi talla',
      'como elegir mi talla',
      'como escoger mi talla',
      'como calcular mi talla',
      'como se mi talla',
      'como medir',
      'como tomar medida',
      'como tomar la medida',
      'como tomar medidas',
      'como se mide el pie',
      'como puedo medir mi pie',
      'como puedo saber mi talla',
      'como puedo verificar mi talla',
      'como puedo revisar mi talla',
      'como puedo corroborar mi talla',
      'como puedo confirmar mi talla',
      'como confirmo mi talla',
      'como verifico mi talla',
      'como reviso mi talla',
      'como corroboro mi talla',
      'como se que talla',
      'como se si talla',
      'como se si la talla',
      'como saber si talla',
      'como saber si la talla',
      'talla me funciona',
      'talla me sirve',
      'talla funciona',
      'talla sirve',
      'numero me funciona',
      'numero me sirve',
      'ayuda con mi talla',
      'me queda',
      'me quedaria',
    ];

    if (matchesAny(text, guideTerms)) return true;

    if (!text.includes('talla') && !text.includes('numero')) return false;

    const fitQuestionTerms = [
        'guia',
        'medir',
        'medida',
        'cuanto',
        'cuantos',
        'centimetro',
        'centimetros',
        'horma',
        'calce',
        'ajuste',
        'duda',
        'saber',
        'soy',
        'verificar',
        'revisar',
        'corroborar',
        'confirmar',
        'validar',
        'elegir',
        'escoger',
        'calcular',
        'queda',
        'quedaria',
        'recomiendas',
        'pedir',
        'compro',
      ];
    const fitQuestionStems = [
      'confirm',
      'verific',
      'revis',
      'corrobor',
      'valid',
      'funcion',
      'sirv',
      'serv',
      'qued',
      'recomend',
      'conviene',
      'apropiad',
      'correct',
      'equivoc',
      'segur',
      'dud',
      'calcul',
      'med',
      'escog',
      'eleg',
    ];

    return matchesAny(text, fitQuestionTerms) || matchesAny(text, fitQuestionStems);
  };

  const unique = (values) => Array.from(new Set(values.filter(Boolean)));

  const isSupportedProduct = (product) =>
    [...shoeWords, ...accessoryWords].some((word) => product.searchable.includes(word));

  const getFocusableElements = () =>
    Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden && element.offsetParent !== null);

  const readStoredState = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
    } catch (error) {
      return null;
    }
  };

  const persistState = () => {
    try {
      const transcript = Array.from(messages.querySelectorAll('[data-assistant-persist="true"]'))
        .slice(-12)
        .map((message) => ({
          type: message.dataset.assistantMessageType || 'bot',
          text: message.textContent.trim().slice(0, 600),
        }))
        .filter((message) => message.text);
      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify({ activeCriteria, conversationTurns, transcript })
      );
    } catch (error) {
      return;
    }
  };

  const restoreState = () => {
    const stored = readStoredState();
    if (!stored) return;
    if (stored.activeCriteria && typeof stored.activeCriteria === 'object') {
      activeCriteria = { ...activeCriteria, ...stored.activeCriteria };
    }
    conversationTurns = Number(stored.conversationTurns) || 0;
    (Array.isArray(stored.transcript) ? stored.transcript : []).forEach((message) => {
      if (!message?.text) return;
      addMessage(message.text, message.type === 'user' ? 'user' : 'bot', false);
    });
  };

  const getProductTags = (tags) => {
    if (Array.isArray(tags)) return tags;
    return String(tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  };

  const extractSizes = (value) => {
    const matches = normalize(value).match(/\b(?:3[5-9]|40)\b/g);
    return matches ? Array.from(new Set(matches)) : [];
  };

  const getUnsupportedShoeSize = (rawText) => {
    const text = normalize(rawText);
    const explicitMatch = text.match(
      /\b(?:talla|numero|calzo|calce|uso|soy|busco|buscar|quiero|necesito|ocupo)\D{0,18}(\d{2})\b/
    );
    const bareMatch = text.match(/^\s*(4[1-9])\s*(?:\?+|!+)?\s*$/);
    const match = explicitMatch || bareMatch;
    const size = Number(match?.[1]);

    return Number.isFinite(size) && size >= 28 && size <= 49 && (size < 35 || size > 40) ? String(size) : '';
  };

  const findGroup = (text, groups) => {
    const matches = Object.entries(groups)
      .flatMap(([group, terms]) =>
        terms.filter((term) => text.includes(term)).map((term) => ({ group, length: term.length }))
      )
      .sort((a, b) => b.length - a.length);

    return matches[0]?.group || '';
  };

  const getKeywordFromText = (text) =>
    text
      .split(/\s+/)
      .filter((word) => word.length > 2 && !searchStopWords.has(word) && !extractSizes(word).length && !/^\d+$/.test(word))
      .slice(0, 4)
      .join(' ');

  const getIntentFromText = (text) =>
    Object.entries(advisorIntents)
      .filter(([, terms]) => matchesAny(text, terms))
      .map(([intent]) => intent);

  const extractBudget = (rawText) => {
    const text = normalize(rawText).replace(/[,.]/g, '');
    const amounts = Array.from(text.matchAll(/\b(?:crc|₡)?\s*(\d{4,7})\b/g))
      .map((match) => Number(match[1]))
      .filter((amount) => Number.isFinite(amount) && amount >= 1000);
    const budgetMax = amounts.length && matchesAny(text, ['menos', 'maximo', 'hasta', 'barato', 'economico'])
      ? String(Math.max(...amounts))
      : '';
    const budgetMin = amounts.length && matchesAny(text, ['mas de', 'minimo', 'desde'])
      ? String(Math.min(...amounts))
      : '';

    return {
      budgetMax: budgetMax || (matchesAny(text, ['barato', 'economico']) ? '25000' : ''),
      budgetMin,
    };
  };

  const whatsappUrl = (message) =>
    `https://wa.me/${config.whatsappNumber}?text=${encodeURIComponent(message)}`;

  const trackEvent = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  };

  const stackWhatsAppButton = () => {
    try {
      const candidates = Array.from(
        new Set(
          Array.from(
            document.querySelectorAll(
              'iframe[src*="dondy"], iframe[src*="whatsapp"], a[href*="wa.me"], a[href*="whatsapp"], [id*="dondy"], [class*="dondy"], #whatsapp-widget-root, #chat-bubble'
            )
          ).map(
            (candidate) =>
              candidate.closest('#whatsapp-widget-root') ||
              candidate
          )
        )
      );

      candidates.forEach((element) => {
        if (root.contains(element)) return;

        const haystack = normalize(
          [
            element.id,
            element.className,
            element.getAttribute('src'),
            element.getAttribute('href'),
            element.getAttribute('aria-label'),
            element.getAttribute('title'),
          ].join(' ')
        );

        const isDondyWidget =
          element.id === 'whatsapp-widget-root' ||
          element.id === 'chat-bubble' ||
          haystack.includes('dondy');

        if (isDondyWidget) {
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
          element.setAttribute('aria-hidden', 'true');
          externalWhatsAppWidgets.delete(element);
          return;
        }

        if (!haystack.includes('wa.me')) return;

        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const isSmallWidget = rect.width <= 140 && rect.height <= 140;
        const isBottomRight = rect.right > window.innerWidth - 180 && rect.bottom > window.innerHeight - 180;

        if (style.position !== 'fixed' && (!isSmallWidget || !isBottomRight)) return;

        element.style.setProperty('position', 'fixed', 'important');
        element.style.setProperty('right', window.innerWidth <= 520 ? '12px' : '18px', 'important');
        element.style.setProperty('left', 'auto', 'important');
        element.style.setProperty('bottom', window.innerWidth <= 520 ? '86px' : '94px', 'important');
        element.style.setProperty('z-index', '69', 'important');
        externalWhatsAppWidgets.add(element);
      });
    } catch (error) {
      // Keep storefront scripts isolated from third-party chat widget changes.
    }
  };

  const syncWhatsAppVisibility = () => {
    stackWhatsAppButton();
    externalWhatsAppWidgets.forEach((element) => {
      if (!document.documentElement.contains(element)) {
        externalWhatsAppWidgets.delete(element);
        return;
      }

      if (panel.hidden) {
        element.style.removeProperty('opacity');
        element.style.removeProperty('pointer-events');
        element.style.removeProperty('visibility');
      } else {
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  };

  const scrollMessages = () => {
    messages.scrollTop = messages.scrollHeight;
  };

  const addMessage = (content, type = 'bot', shouldPersist = true) => {
    const message = document.createElement('div');
    message.className = `velae-assistant__message velae-assistant__message--${type}`;
    message.dataset.assistantMessageType = type;

    if (typeof content === 'string') {
      message.textContent = content;
    } else {
      message.append(content);
    }

    messages.append(message);
    if (shouldPersist) {
      message.dataset.assistantPersist = 'true';
      persistState();
    }
    scrollMessages();
    return message;
  };

  const clearSearchMessages = () => {
    messages.querySelectorAll('[data-assistant-search-result], .velae-assistant__product').forEach((node) => {
      node.closest('.velae-assistant__message')?.remove();
    });
  };

  const makeAction = (label, href, modifier = '') => {
    const link = document.createElement('a');
    link.className = `velae-assistant__action ${modifier}`;
    link.href = href;
    link.textContent = label;
    if (href.startsWith('https://wa.me/')) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.addEventListener('click', () => {
        trackEvent('velae_assistant_whatsapp_click', { label });
      });
    } else if (href.startsWith('http')) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
    return link;
  };

  const makeButton = (label, value) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'velae-assistant__suggestion';
    button.dataset.assistantSuggestion = value;
    button.textContent = label;
    return button;
  };

  const makeChipButton = (label, value) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.assistantChip = value;
    button.textContent = label;
    return button;
  };

  const getSizedImageUrl = (source, width = 480) => {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return source;
    }
  };

  const addVariantToCart = async (variantId, button) => {
    if (!variantId || button.disabled) return;
    const originalLabel = button.textContent;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    if (cart?.getSectionsToRender) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(button);
    }

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Agregando';

    try {
      const response = await fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'No se pudo agregar');

      if (cart?.renderContents) {
        cart.classList.remove('is-empty');
        addMessage('Listo. Agregue la variante seleccionada a tu carrito.');
        closePanel();
        cart.setActiveElement?.(toggle);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'velae-assistant',
            productVariantId: String(variantId),
            cartData: result,
          });
        }
        cart.renderContents(result);
      } else {
        window.location.assign(config.cartUrl);
        return;
      }

      button.textContent = 'Agregado';
      trackEvent('velae_assistant_add_to_cart', { variantId: String(variantId) });
      window.setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      }, 1800);
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalLabel;
      addMessage('No pude agregar esa variante. Puede haberse agotado hace un momento; intenta otra o abre el producto.');
    }
  };

  const openPanel = () => {
    previousFocus = document.activeElement;
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    syncWhatsAppVisibility();
    updateSmartChips();
    renderCurrentProductContext();
    renderCollectionContext();
    trackEvent('velae_assistant_open');
    window.setTimeout(() => input.focus(), 80);
  };

  const closePanel = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    syncWhatsAppVisibility();
    persistState();
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  };

  const setBusy = (busy) => {
    messages.setAttribute('aria-busy', String(busy));
    sendButton.disabled = busy;
    sendButton.classList.toggle('is-loading', busy);
    sendButton.textContent = busy ? 'Revisando' : 'Enviar';
  };

  const toMoney = (value) => {
    const amount = getPriceNumber(value);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('es-CR', {
      style: 'currency',
      currency: 'CRC',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getPriceNumber = (value) => {
    const normalizedValue = typeof value === 'string' ? value.replace(/[^\d.-]/g, '') : value;
    const amount = Number(normalizedValue);
    return Number.isFinite(amount) ? amount : 0;
  };

  const getAvailableSizes = (variants) =>
    Array.from(new Set(variants.filter((variant) => variant.available).flatMap((variant) => extractSizes(variant.title))))
      .sort((a, b) => Number(a) - Number(b));

  const getVariantText = (variant) =>
    normalize([variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' '));

  const getVariantFacts = (variant, fallbackColors = []) => {
    const text = getVariantText(variant);
    const colors = getMatchesFromGroups(text, colorGroups);
    const sizes = extractSizes(text);

    return {
      id: variant.id,
      title: variant.title,
      price: variant.price,
      image: variant.image || '',
      text,
      sizes,
      colors: colors.length ? colors : fallbackColors.length === 1 ? fallbackColors : [],
    };
  };

  const getProductTypes = (text) =>
    Object.entries(typeGroups)
      .filter(([, terms]) => matchesAny(text, terms))
      .map(([type]) => type);

  const getMatchesFromGroups = (text, groups) =>
    Object.entries(groups)
      .filter(([, terms]) => matchesAny(text, terms))
      .map(([key]) => key);

  const cleanTagValue = (value) => normalize(value).replace(/[_-]/g, ' ').replace(/\s+/g, ' ').trim();

  const parseStructuredTags = (tags = []) => {
    const attrs = {
      colors: [],
      styles: [],
      occasions: [],
      feels: [],
      heels: [],
      materials: [],
      fits: [],
    };

    tags.forEach((tag) => {
      const normalizedTag = cleanTagValue(tag);
      const [rawKey, ...rawValueParts] = normalizedTag.split(/[:=]/);
      const key = normalize(rawKey || '');
      const value = cleanTagValue(rawValueParts.join(':') || normalizedTag);

      if (['color', 'tono'].includes(key)) attrs.colors.push(...getMatchesFromGroups(value, colorGroups));
      if (['estilo', 'tipo', 'categoria'].includes(key)) attrs.styles.push(...getMatchesFromGroups(value, typeGroups));
      if (['ocasion', 'uso'].includes(key)) attrs.occasions.push(...getMatchesFromGroups(value, occasionGroups));
      if (['comodidad', 'confort'].includes(key)) {
        attrs.feels.push(...getMatchesFromGroups(value, feelGroups));
        if (matchesAny(value, ['alta', 'alto', 'comodo', 'comoda'])) attrs.feels.push('comodo');
      }
      if (['tacon', 'altura'].includes(key)) {
        if (matchesAny(value, ['bajo', 'baja'])) attrs.heels.push('bajo');
        if (matchesAny(value, ['alto', 'alta'])) attrs.heels.push('alto');
      }
      if (key.includes('material')) attrs.materials.push(value);
      if (key.includes('horma')) attrs.fits.push(value);

      attrs.colors.push(...getMatchesFromGroups(normalizedTag, colorGroups));
      attrs.styles.push(...getMatchesFromGroups(normalizedTag, typeGroups));
      attrs.occasions.push(...getMatchesFromGroups(normalizedTag, occasionGroups));
      attrs.feels.push(...getMatchesFromGroups(normalizedTag, feelGroups));
    });

    return Object.fromEntries(
      Object.entries(attrs).map(([key, values]) => [key, unique(values).slice(0, 6)])
    );
  };

  const getCatalog = async () => {
    if (!catalogPromise) {
      catalogPromise = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Catalog failed: ${response.status}`);
          return response.json();
        })
        .then((data) =>
          (data.products || []).map((product) => {
            const variants = product.variants || [];
            const availableVariants = variants.filter((variant) => variant.available);
            const firstAvailable = availableVariants[0] || variants[0] || {};
            const availablePrices = availableVariants
              .map((variant) => getPriceNumber(variant.price))
              .filter((price) => price > 0);
            const productTags = getProductTags(product.tags);
            const titleText = normalize([product.title, product.handle, product.product_type].join(' '));
            const bodyText = normalize(product.body_html?.replace(/<[^>]+>/g, ' ') || '');
            const tagText = normalize(productTags.join(' '));
            const structuredTags = parseStructuredTags(productTags);
            const productTextColors = unique([
              ...getMatchesFromGroups([titleText, tagText].join(' '), colorGroups),
              ...structuredTags.colors,
            ]);
            const availableVariantFacts = availableVariants.map((variant) => getVariantFacts(variant, productTextColors));
            const variantEntries = availableVariantFacts.map((variant) => variant.text);
            const variantText = variantEntries.join(' ');
            const searchable = [titleText, bodyText, tagText, variantText].join(' ');
            const availableSizes = unique(availableVariantFacts.flatMap((variant) => variant.sizes)).sort(
              (a, b) => Number(a) - Number(b)
            );
            const availableColors = unique([
              ...availableVariantFacts.flatMap((variant) => variant.colors),
              ...productTextColors,
            ]);
            const productTypes = unique([...getProductTypes(searchable), ...structuredTags.styles]);

            return {
              title: product.title,
              price: toMoney(firstAvailable.price),
              priceNumber: availablePrices.length ? Math.min(...availablePrices) : getPriceNumber(firstAvailable.price),
              url: `/products/${product.handle}`,
              image: product.images?.[0]?.src || '',
              alt: product.title,
              available: availableVariants.length > 0,
              availableSizes,
              availableColors,
              productTypes,
              occasions: structuredTags.occasions,
              feels: structuredTags.feels,
              heels: structuredTags.heels,
              materials: structuredTags.materials,
              fits: structuredTags.fits,
              titleText,
              bodyText,
              tagText,
              variantText,
              variantEntries,
              availableVariantFacts,
              searchable,
            };
          })
        )
        .catch((error) => {
          catalogPromise = null;
          throw error;
        });
    }

    return catalogPromise;
  };

  const countValues = (values) =>
    values.reduce((counts, value) => {
      if (!value) return counts;
      counts[value] = (counts[value] || 0) + 1;
      return counts;
    }, {});

  const getTopValues = (counts, limit) =>
    Object.entries(counts)
      .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
      .slice(0, limit)
      .map(([value]) => value);

  const updateSmartChips = async () => {
    if (!config.smartChipsEnabled || smartChipsReady || !chipsContainer) return;
    smartChipsReady = true;

    try {
      const catalog = await getCatalog();
      const supportedProducts = catalog.filter((product) => product.available && isSupportedProduct(product));
      const topSizes = getTopValues(countValues(supportedProducts.flatMap((product) => product.availableSizes)), 3);
      const topColors = getTopValues(countValues(supportedProducts.flatMap((product) => product.availableColors)), 3);
      const topTypes = getTopValues(countValues(supportedProducts.flatMap((product) => product.productTypes)), 3);
      const chipItems = [
        ...baseQuickPrompts,
        ...topSizes.map((size) => ({ label: `Talla ${size}`, value: size })),
        ...topColors.map((color) => ({ label: color.charAt(0).toUpperCase() + color.slice(1), value: color })),
        ...topTypes.map((type) => ({ label: type.charAt(0).toUpperCase() + type.slice(1), value: type })),
        { label: 'Envios', value: 'envios' },
      ];

      if (!chipItems.length) return;
      const uniqueChips = Array.from(
        new Map(chipItems.map((chip) => [normalize(chip.value), chip])).values()
      ).slice(0, 10);
      chipsContainer.replaceChildren(...uniqueChips.map((chip) => makeChipButton(chip.label, chip.value)));
    } catch (error) {
      smartChipsReady = false;
    }
  };

  const getCurrentProductFacts = () => {
    const product = config.currentProduct || {};
    const variants = product.availableVariants || [];
    const tags = getProductTags(product.tags);
    const titleText = normalize([product.title, product.type, product.vendor].filter(Boolean).join(' '));
    const descriptionText = normalize(product.description || '');
    const tagText = normalize(tags.join(' '));
    const structuredTags = parseStructuredTags(tags);
    const productTextColors = unique([
      ...getMatchesFromGroups([titleText, descriptionText, tagText].join(' '), colorGroups),
      ...structuredTags.colors,
    ]);
    const availableVariantFacts = variants.map((variant) => getVariantFacts(variant, productTextColors));

    return {
      title: product.title,
      url: product.url,
      image: product.image,
      available: product.available,
      type: product.type,
      vendor: product.vendor,
      description: product.description,
      options: product.options || [],
      selectedVariantId: product.selectedVariantId,
      availableVariantFacts,
      availableSizes: unique(availableVariantFacts.flatMap((variant) => variant.sizes)).sort(
        (a, b) => Number(a) - Number(b)
      ),
      availableColors: unique([
        ...availableVariantFacts.flatMap((variant) => variant.colors),
        ...productTextColors,
      ]),
      productTypes: unique([...getProductTypes([titleText, descriptionText, tagText].join(' ')), ...structuredTags.styles]),
      occasions: structuredTags.occasions,
      feels: structuredTags.feels,
    };
  };

  const renderCurrentProductContext = () => {
    if (!config.productContextEnabled || productContextShown || !config.currentProduct?.title) return;
    productContextShown = true;

    const product = getCurrentProductFacts();
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    const quickActions = document.createElement('div');
    actions.className = 'velae-assistant__context-actions';
    quickActions.className = 'velae-assistant__suggestions';

    if (product.available) {
      const sizes = product.availableSizes.length ? ` Disponible en talla ${product.availableSizes.join(', ')}.` : '';
      const colors = product.availableColors.length ? ` Tono: ${product.availableColors.join(', ')}.` : '';
      const use = product.occasions.length ? ` Lo veo bien para ${product.occasions.slice(0, 2).join(' o ')}.` : '';
      text.textContent = `Estas viendo ${product.title}.${sizes}${colors}${use} Puedo ayudarte a elegir variante o compararlo con opciones similares.`;
    } else {
      text.textContent = `Estas viendo ${product.title}, pero no lo veo disponible ahora. Puedo buscarte alternativas similares o pasarte con una asesora.`;
    }

    if (product.image) {
      const image = document.createElement('img');
      image.className = 'velae-assistant__context-image';
      image.src = getSizedImageUrl(product.image, 320);
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 96;
      image.height = 120;
      wrapper.append(image);
    }

    if (product.availableVariantFacts.length) {
      const selectedVariant =
        product.availableVariantFacts.find((variant) => String(variant.id) === String(product.selectedVariantId)) ||
        product.availableVariantFacts[0];
      const field = document.createElement('label');
      const label = document.createElement('span');
      const select = document.createElement('select');
      const addButton = document.createElement('button');
      const selectId = `velae-current-variant-${Date.now()}`;
      field.className = 'velae-assistant__variant-field velae-assistant__variant-field--context';
      label.className = 'velae-assistant__variant-label';
      select.className = 'velae-assistant__variant-select';
      select.id = selectId;
      field.setAttribute('for', selectId);
      label.textContent = 'Variante disponible';
      addButton.className = 'velae-assistant__add-to-cart';
      addButton.type = 'button';
      addButton.textContent = 'Agregar este producto';
      addButton.setAttribute('aria-label', `Agregar ${product.title} al carrito`);
      product.availableVariantFacts.forEach((variant) => {
        if (!variant.id) return;
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = `${variant.title} · ${toMoney(variant.price)}`;
        option.selected = variant.id === selectedVariant?.id;
        select.append(option);
      });
      addButton.addEventListener('click', () => addVariantToCart(select.value, addButton));
      field.append(label, select);
      actions.append(field, addButton);
    }

    quickActions.append(
      makeButton('Buscar similares', product.title),
      makeButton('Comparar por ocasion', [product.availableSizes[0], product.occasions[0] || 'evento'].filter(Boolean).join(' ')),
      makeAction(
        'WhatsApp',
        whatsappUrl(`Hola, necesito ayuda con ${product.title}. Producto: ${window.location.origin}${product.url || ''}`),
        'velae-assistant__action--whatsapp'
      )
    );
    wrapper.append(text);
    if (actions.children.length) wrapper.append(actions);
    wrapper.append(quickActions);
    addMessage(wrapper);
  };

  const renderCollectionContext = () => {
    const collection = config.collectionContext || {};
    if (collectionContextShown || config.currentProduct?.title || !collection.title) return;
    collectionContextShown = true;

    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__suggestions';
    text.textContent = `Estas viendo ${collection.title}. Puedo filtrar por talla, tono u ocasion y mostrarte solo opciones disponibles.`;
    actions.append(
      makeButton('Talla 37', '37'),
      makeButton('Para evento', `${collection.title} evento`),
      makeButton('Comodos', `${collection.title} comodos`),
      makeAction('Ver coleccion', collection.url || window.location.pathname, 'velae-assistant__action--secondary')
    );
    wrapper.append(text, actions);
    addMessage(wrapper);
  };

  const getCriteriaFromText = (rawText) => {
    const text = normalize(rawText);
    const size = extractSizes(text).slice(-1)[0] || '';
    const color = findGroup(text, colorGroups);
    const type = findGroup(text, typeGroups);
    const occasion = findGroup(text, occasionGroups);
    const feel = findGroup(text, feelGroups);
    const budget = extractBudget(rawText);
    const intents = getIntentFromText(text);

    return {
      size,
      color,
      type,
      occasion,
      feel,
      budgetMax: budget.budgetMax,
      budgetMin: budget.budgetMin,
      query: getKeywordFromText(text),
      intents,
      reset: matchesAny(text, ['limpiar', 'borrar', 'empezar', 'nueva busqueda', 'otra busqueda']),
    };
  };

  const mergeCriteria = (rawText) => {
    const parsed = getCriteriaFromText(rawText);
    const typedOnlySize = parsed.size && !parsed.color && !parsed.type && !parsed.occasion && !parsed.feel && !parsed.budgetMax && !parsed.budgetMin;

    if (parsed.reset) {
      activeCriteria = { size: '', color: '', type: '', occasion: '', feel: '', budgetMax: '', budgetMin: '', query: '' };
      return activeCriteria;
    }

    if (typedOnlySize) {
      activeCriteria = {
        size: parsed.size,
        color: '',
        type: '',
        occasion: '',
        feel: '',
        budgetMax: '',
        budgetMin: '',
        query: '',
      };
      return activeCriteria;
    }

    activeCriteria = {
      size: parsed.size || activeCriteria.size,
      color: parsed.color || activeCriteria.color,
      type: parsed.type || activeCriteria.type,
      occasion: parsed.occasion || activeCriteria.occasion,
      feel: parsed.feel || activeCriteria.feel,
      budgetMax: parsed.budgetMax || activeCriteria.budgetMax,
      budgetMin: parsed.budgetMin || activeCriteria.budgetMin,
      query: parsed.query || (parsed.color || parsed.type || parsed.occasion || parsed.feel ? '' : activeCriteria.query),
    };

    return activeCriteria;
  };

  const getActiveTerms = (criteria) =>
    [criteria.size, criteria.color, criteria.type, criteria.occasion, criteria.feel, criteria.budgetMax, criteria.budgetMin, criteria.query].filter(Boolean);

  const describeCriteria = (criteria) => {
    const parts = [];
    if (criteria.size) parts.push(`talla ${criteria.size}`);
    if (criteria.color) parts.push(criteria.color);
    if (criteria.type) parts.push(criteria.type);
    if (criteria.occasion) parts.push(`para ${criteria.occasion}`);
    if (criteria.feel) parts.push(criteria.feel);
    if (criteria.budgetMax) parts.push(`hasta ₡${Number(criteria.budgetMax).toLocaleString('es-CR')}`);
    if (criteria.budgetMin) parts.push(`desde ₡${Number(criteria.budgetMin).toLocaleString('es-CR')}`);
    if (criteria.query) parts.push(criteria.query);
    return parts.length ? parts.join(', ') : 'sin filtros especificos';
  };

  const getRecommendationReason = (product, criteria) => {
    const reasons = [];
    const bestVariant = getBestVariantForCriteria(product, criteria);

    if (criteria.size && product.availableSizes.includes(criteria.size)) reasons.push(`tiene talla ${criteria.size}`);
    if (criteria.color && bestVariant?.colors.includes(criteria.color)) reasons.push(`coincide en ${criteria.color}`);
    if (criteria.type && product.productTypes.includes(criteria.type)) reasons.push(`es estilo ${criteria.type}`);
    if (criteria.occasion && product.occasions.includes(criteria.occasion)) reasons.push(`va bien para ${criteria.occasion}`);
    if (criteria.feel && (product.feels.includes(criteria.feel) || product.heels.includes(criteria.feel))) reasons.push(`cumple con ${criteria.feel}`);
    if (criteria.budgetMax && product.priceNumber && product.priceNumber <= Number(criteria.budgetMax)) reasons.push('entra en tu presupuesto');
    if (!reasons.length && product.availableSizes.length) reasons.push(`tiene disponibilidad real en talla ${product.availableSizes.slice(0, 3).join(', ')}`);

    return `Eva lo eligio porque ${reasons.slice(0, 3).join(', ')}.`;
  };

  const getBestVariantForCriteria = (product, criteria) =>
    product.availableVariantFacts.find(
      (variant) =>
        (!criteria.size || variant.sizes.includes(criteria.size)) &&
        (!criteria.color || variant.colors.includes(criteria.color))
    ) ||
    product.availableVariantFacts.find((variant) => !criteria.color || variant.colors.includes(criteria.color)) ||
    product.availableVariantFacts.find((variant) => !criteria.size || variant.sizes.includes(criteria.size)) ||
    product.availableVariantFacts[0] ||
    null;

  const getDisplaySizes = (product, criteria) => {
    const variants = criteria.color
      ? product.availableVariantFacts.filter((variant) => variant.colors.includes(criteria.color))
      : product.availableVariantFacts;
    const sizes = unique(variants.flatMap((variant) => variant.sizes)).sort((a, b) => Number(a) - Number(b));
    return sizes.length ? sizes : product.availableSizes;
  };

  const productWhatsAppUrl = (product, criteria, query) => {
    const bestVariant = getBestVariantForCriteria(product, criteria);
    const size = bestVariant?.sizes[0] || criteria.size || product.availableSizes[0] || '';
    const color = bestVariant?.colors[0] || criteria.color || product.availableColors[0] || '';
    const message = [
      `Hola, me interesa ${product.title}.`,
      size ? `Talla: ${size}.` : '',
      color ? `Color/tono: ${color}.` : '',
      bestVariant?.title ? `Variante disponible: ${bestVariant.title}.` : '',
      `Busqueda: ${query || describeCriteria(criteria)}.`,
      `Producto: ${window.location.origin}${product.url}`,
    ]
      .filter(Boolean)
      .join(' ');

    return whatsappUrl(message);
  };

  const variantHasSizeAndColor = (product, criteria) => {
    const hasVariantMatch = product.availableVariantFacts.some(
      (variant) =>
        (!criteria.size || variant.sizes.includes(criteria.size)) &&
        (!criteria.color || variant.colors.includes(criteria.color))
    );

    return hasVariantMatch;
  };

  const productMatchesKeyword = (product, query) => {
    if (!query) return true;
    const words = query.split(/\s+/).filter(Boolean);
    if (!words.length) return true;
    return words.every((word) => product.searchable.includes(word));
  };

  const scoreProduct = (product, criteria) => {
    if (!product.available) return -1;
    if (!isSupportedProduct(product)) return -1;

    let score = 0;

    if (criteria.query) {
      if (!productMatchesKeyword(product, criteria.query)) return -1;
      score += product.titleText.includes(criteria.query) ? 95 : 45;
    }

    if (criteria.size) {
      if (!product.availableSizes.includes(criteria.size)) return -1;
      score += 120;
    }

    if (criteria.color) {
      if (!product.availableColors.includes(criteria.color)) return -1;
      if (!variantHasSizeAndColor(product, criteria)) return -1;
      score += 85;
    }

    if (criteria.type) {
      const aliases = typeGroups[criteria.type] || [criteria.type];
      if (!aliases.some((term) => product.searchable.includes(term)) && !product.productTypes.includes(criteria.type)) return -1;
      score += product.productTypes.includes(criteria.type) ? 70 : 50;
    }

    if (criteria.occasion) {
      const aliases = occasionGroups[criteria.occasion] || [criteria.occasion];
      if (product.occasions.includes(criteria.occasion)) score += 45;
      else if (aliases.some((term) => product.searchable.includes(term))) score += 28;
    }

    if (criteria.feel) {
      const aliases = feelGroups[criteria.feel] || [criteria.feel];
      if (product.feels.includes(criteria.feel) || product.heels.includes(criteria.feel)) score += 40;
      else if (aliases.some((term) => product.searchable.includes(term))) score += 24;
    }

    if (criteria.budgetMax) {
      const matchingPrice = getPriceNumber(getBestVariantForCriteria(product, criteria)?.price) || product.priceNumber;
      if (!matchingPrice || matchingPrice > Number(criteria.budgetMax)) return -1;
      score += 32;
    }

    if (criteria.budgetMin) {
      const matchingPrice = getPriceNumber(getBestVariantForCriteria(product, criteria)?.price) || product.priceNumber;
      if (!matchingPrice || matchingPrice < Number(criteria.budgetMin)) return -1;
      score += 18;
    }

    score += Math.min(product.availableSizes.length, 5);
    if (criteria.size && criteria.color && variantHasSizeAndColor(product, criteria)) score += 30;
    return score;
  };

  const searchProducts = async (criteria) => {
    const catalog = await getCatalog();
    const terms = getActiveTerms(criteria);

    if (!terms.length) {
      return {
        products: catalog
          .filter((product) => product.available && isSupportedProduct(product))
          .slice(0, 8),
        relaxed: false,
        fallbackNote: '',
      };
    }

    const scored = catalog
      .map((product) => ({ product, score: scoreProduct(product, criteria) }))
      .filter((item) => item.score >= 0)
      .sort((a, b) => b.score - a.score)
      .map((item) => item.product);

    if (scored.length || !(criteria.color || criteria.type || criteria.occasion || criteria.feel || criteria.budgetMax || criteria.budgetMin)) {
      return { products: scored.slice(0, 12), relaxed: false, fallbackNote: '' };
    }

    if (criteria.size && criteria.color) {
      const sizeOnlyCriteria = { ...criteria, color: '' };
      const sizeMatches = catalog
        .map((product) => ({ product, score: scoreProduct(product, sizeOnlyCriteria) }))
        .filter((item) => item.score >= 0)
        .sort((a, b) => b.score - a.score)
        .map((item) => item.product);

      if (sizeMatches.length) {
        return {
          products: sizeMatches.slice(0, 8),
          relaxed: true,
          fallbackNote: `No vi ${criteria.color} disponible en talla ${criteria.size}. Te muestro primero opciones que si tienen talla ${criteria.size}, para no perder el ajuste que pediste.`,
        };
      }

      const colorOnlyCriteria = { ...criteria, size: '' };
      const colorMatches = catalog
        .map((product) => ({ product, score: scoreProduct(product, colorOnlyCriteria) }))
        .filter((item) => item.score >= 0)
        .sort((a, b) => b.score - a.score)
        .map((item) => item.product);

      if (colorMatches.length) {
        return {
          products: colorMatches.slice(0, 8),
          relaxed: true,
          fallbackNote: `No encontre ${criteria.color} disponible en talla ${criteria.size}. Te muestro opciones ${criteria.color} en las tallas que si estan disponibles.`,
        };
      }
    }

    if (criteria.size && (criteria.type || criteria.occasion || criteria.feel || criteria.query)) {
      const intentOnlyCriteria = { ...criteria, size: '' };
      const intentMatches = catalog
        .map((product) => ({ product, score: scoreProduct(product, intentOnlyCriteria) }))
        .filter((item) => item.score >= 0)
        .sort((a, b) => b.score - a.score)
        .map((item) => item.product);

      if (intentMatches.length) {
        return {
          products: intentMatches.slice(0, 8),
          relaxed: true,
          fallbackNote: `No encontre una coincidencia exacta en talla ${criteria.size}. Te muestro opciones cercanas con las tallas disponibles.`,
        };
      }
    }

    if (criteria.color && !criteria.size) {
      return {
        products: [],
        relaxed: false,
        fallbackNote: `No encontre opciones disponibles en color ${criteria.color}.`,
      };
    }

    const relaxedCriteria = { ...criteria, color: '', type: '', occasion: '', feel: '', budgetMax: '', budgetMin: '' };
    const relaxed = catalog
      .map((product) => ({ product, score: scoreProduct(product, relaxedCriteria) }))
      .filter((item) => item.score >= 0)
      .sort((a, b) => b.score - a.score)
      .map((item) => item.product);

    return {
      products: relaxed.slice(0, 8),
      relaxed: relaxed.length > 0,
      fallbackNote: relaxed.length
        ? criteria.size
          ? `No vi una coincidencia exacta con todos los filtros. Te muestro opciones disponibles en talla ${criteria.size}.`
          : 'No vi una coincidencia exacta con todos los filtros. Te muestro opciones disponibles cercanas a lo que pediste.'
        : '',
    };
  };

  const renderCriteria = (criteria) => {
    const parts = [];
    if (criteria.size) parts.push(`Talla ${criteria.size}`);
    if (criteria.color) parts.push(criteria.color);
    if (criteria.type) parts.push(criteria.type);
    if (criteria.occasion) parts.push(criteria.occasion);
    if (criteria.feel) parts.push(criteria.feel);
    if (criteria.budgetMax) parts.push(`Hasta ₡${Number(criteria.budgetMax).toLocaleString('es-CR')}`);
    if (criteria.budgetMin) parts.push(`Desde ₡${Number(criteria.budgetMin).toLocaleString('es-CR')}`);
    if (criteria.query) parts.push(criteria.query);

    if (!parts.length) return null;

    const row = document.createElement('div');
    row.className = 'velae-assistant__criteria';
    parts.forEach((part) => {
      const pill = document.createElement('span');
      pill.textContent = part;
      row.append(pill);
    });
    row.append(makeButton('Limpiar', 'limpiar'));
    return row;
  };

  const renderGuidedAdvisor = (query, criteria) => {
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__suggestions';
    text.textContent =
      'Claro, soy Eva. Para recomendarte mejor dime la ocasion, talla, color o presupuesto. Tambien puedo ayudarte con bolsos y accesorios.';
    actions.append(
      makeButton('Diario comodo', [criteria.size, 'comodo diario'].filter(Boolean).join(' ')),
      makeButton('Oficina elegante', [criteria.size, 'elegante oficina'].filter(Boolean).join(' ')),
      makeButton('Evento de noche', [criteria.size, 'dorado fiesta'].filter(Boolean).join(' ')),
      makeButton('Bolsos y accesorios', 'bolsos accesorios'),
      makeButton('Para regalo', [criteria.size, 'regalo versatil'].filter(Boolean).join(' ')),
      makeButton('Menos de ₡25.000', [criteria.size, criteria.color, 'menos de 25000'].filter(Boolean).join(' '))
    );
    wrapper.append(text, actions);
    addMessage(wrapper);
    trackEvent('velae_assistant_guided_advisor', { turn: conversationTurns });
  };

  const renderGiftAdvisor = (criteria) => {
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__suggestions';
    text.textContent =
      'Para regalo, te recomiendo empezar por opciones versatiles: tonos neutros, bolsos o calzado comodo. Si no sabes la talla, un accesorio suele ser la opcion mas segura.';
    actions.append(
      makeButton('Bolsos para regalo', 'bolsos regalo'),
      makeButton('Tonos neutros', 'beige negro regalo'),
      makeButton('Comodos para diario', [criteria.size, 'diario comodo'].filter(Boolean).join(' ')),
      makeButton('Menos de ₡25.000', 'regalo menos de 25000'),
      makeAction(
        'Pedir ayuda por WhatsApp',
        whatsappUrl('Hola, necesito ayuda para elegir un regalo en VELAE.'),
        'velae-assistant__action--whatsapp'
      )
    );
    wrapper.append(text, actions);
    addMessage(wrapper);
  };

  const renderSuggestions = (products, criteria) => {
    const row = document.createElement('div');
    row.className = 'velae-assistant__suggestions';

    if (!criteria.size) {
      ['35', '36', '37', '38', '39', '40'].forEach((size) => row.append(makeButton(`Talla ${size}`, size)));
    } else if (!criteria.color) {
      const colors = Array.from(new Set(products.flatMap((product) => product.availableColors))).slice(0, 5);
      colors.forEach((color) => row.append(makeButton(color, `${criteria.size} ${color}`)));
    } else if (!criteria.type) {
      ['sandalias', 'tacones', 'botas', 'tenis', 'bolsos'].forEach((type) =>
        row.append(makeButton(type, [criteria.size, criteria.color, type].filter(Boolean).join(' ')))
      );
    }

    if (!row.children.length) {
      row.append(makeButton('Ver comodos', [criteria.size, criteria.color, 'comodos'].filter(Boolean).join(' ')));
      row.append(makeButton('Ver elegantes', [criteria.size, criteria.color, 'elegantes'].filter(Boolean).join(' ')));
      row.append(makeButton('Para regalo', [criteria.size, criteria.color, 'regalo'].filter(Boolean).join(' ')));
    }

    return row;
  };

  const renderProducts = ({ products, relaxed, fallbackNote }, query, criteria) => {
    clearSearchMessages();

    const wrapper = document.createElement('div');
    wrapper.dataset.assistantSearchResult = 'true';

    const intro = document.createElement('p');
    const visibleCount = Math.min(products.length, 8);
    intro.textContent = products.length
      ? `Encontre ${visibleCount} opcion${visibleCount === 1 ? '' : 'es'} para "${query}". Te las ordene por disponibilidad real y coincidencia con lo que pediste.`
      : `No encontre opciones disponibles para "${query}".`;
    wrapper.append(intro);

    const criteriaRow = renderCriteria(criteria);
    if (criteriaRow) wrapper.append(criteriaRow);

    if (fallbackNote) {
      const note = document.createElement('p');
      note.className = 'velae-assistant__note';
      note.textContent = fallbackNote;
      wrapper.append(note);
    }

    if (products.length) {
      const results = document.createElement('div');
      results.className = 'velae-assistant__results velae-assistant__results--products';

      products.slice(0, 8).forEach((product) => {
        const displaySizes = getDisplaySizes(product, criteria);
        const bestVariant = getBestVariantForCriteria(product, criteria);
        const card = document.createElement('article');
        card.className = 'velae-assistant__product';

        const imageSource = bestVariant?.image || product.image;
        if (imageSource) {
          const image = document.createElement('img');
          image.src = getSizedImageUrl(imageSource);
          image.alt = product.alt;
          image.loading = 'lazy';
          image.width = 480;
          image.height = 600;
          card.append(image);
        }

        const copy = document.createElement('span');
        const title = document.createElement('a');
        const price = document.createElement('span');
        const meta = document.createElement('span');
        const details = document.createElement('span');
        const badge = document.createElement('span');
        const variantField = document.createElement('label');
        const variantLabel = document.createElement('span');
        const variantSelect = document.createElement('select');
        const addButton = document.createElement('button');
        const cardActions = document.createElement('span');
        title.className = 'velae-assistant__product-title';
        title.href = product.url;
        price.className = 'velae-assistant__product-price';
        meta.className = 'velae-assistant__product-meta';
        details.className = 'velae-assistant__product-details';
        badge.className = 'velae-assistant__product-badge';
        variantField.className = 'velae-assistant__variant-field';
        variantLabel.className = 'velae-assistant__variant-label';
        variantSelect.className = 'velae-assistant__variant-select';
        addButton.className = 'velae-assistant__add-to-cart';
        addButton.type = 'button';
        addButton.textContent = 'Agregar al carrito';
        addButton.setAttribute('aria-label', `Agregar ${product.title} al carrito`);
        cardActions.className = 'velae-assistant__product-actions';
        const variantSelectId = `velae-variant-${String(product.title).replace(/\W+/g, '-').toLowerCase()}-${Math.floor(Math.random() * 100000)}`;
        variantSelect.id = variantSelectId;
        variantField.setAttribute('for', variantSelectId);
        title.textContent = product.title;
        price.textContent = toMoney(bestVariant?.price) || product.price || 'Ver detalles';
        badge.textContent = bestVariant ? 'Disponible ahora' : 'Revisar disponibilidad';
        meta.textContent = displaySizes.length
          ? `Tallas disponibles: ${displaySizes.join(', ')}`
          : 'Disponibilidad en producto';
        details.textContent = [
          getRecommendationReason(product, criteria),
          product.availableColors.length ? `Tonos: ${product.availableColors.slice(0, 3).join(', ')}` : '',
          product.productTypes.length ? `Estilo: ${product.productTypes.slice(0, 2).join(', ')}` : '',
          product.occasions.length ? `Ocasion: ${product.occasions.slice(0, 2).join(', ')}` : '',
          product.materials.length ? `Material: ${product.materials.slice(0, 1).join(', ')}` : '',
          product.fits.length ? `Horma: ${product.fits.slice(0, 1).join(', ')}` : '',
        ]
          .filter(Boolean)
          .join(' · ');
        variantLabel.textContent = 'Selecciona variante';
        product.availableVariantFacts.forEach((variant) => {
          if (!variant.id) return;
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = `${variant.title} · ${toMoney(variant.price)}`;
          option.selected = String(variant.id) === String(bestVariant?.id);
          variantSelect.append(option);
        });
        variantField.append(variantLabel, variantSelect);
        addButton.disabled = !variantSelect.options.length;
        addButton.addEventListener('click', () => addVariantToCart(variantSelect.value, addButton));
        cardActions.append(
          makeAction('Ver', product.url, 'velae-assistant__action--secondary'),
          makeAction('Consultar', productWhatsAppUrl(product, criteria, query), 'velae-assistant__action--whatsapp')
        );
        copy.append(badge, title, price, meta);
        if (details.textContent) copy.append(details);
        if (variantSelect.options.length) copy.append(variantField);
        copy.append(addButton);
        copy.append(cardActions);
        card.append(copy);
        results.append(card);
      });

      wrapper.append(results);
      wrapper.append(renderSuggestions(products, criteria));
    } else {
      const actions = document.createElement('div');
      actions.className = 'velae-assistant__results';
      actions.append(
        makeAction(
          'Hablar por WhatsApp',
          whatsappUrl(`Hola, necesito ayuda para elegir zapatos. Busco: ${query}`),
          'velae-assistant__action--whatsapp'
        )
      );
      wrapper.append(actions);
    }

    if (products.length) {
      const actions = document.createElement('div');
      actions.className = 'velae-assistant__results';
      actions.append(
        makeAction(
          products.length > 8 ? 'Ver todos los resultados' : 'Ver mas en la tienda',
          `${config.searchUrl}?q=${encodeURIComponent(getActiveTerms(criteria).join(' ') || query)}&type=product`
        ),
        makeAction(
          'Hablar por WhatsApp',
          whatsappUrl(`Hola, necesito ayuda para elegir zapatos. Busco: ${query}`),
          'velae-assistant__action--whatsapp'
        )
      );
      wrapper.append(actions);
    }

    addMessage(wrapper);
  };

  const openSizeGuideLightbox = (imageUrl, altText) => {
    if (!imageUrl) return;

    const existing = document.querySelector('[data-assistant-size-guide-lightbox]');
    existing?.remove();

    const lightbox = document.createElement('div');
    lightbox.className = 'velae-assistant__lightbox';
    lightbox.dataset.assistantSizeGuideLightbox = 'true';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Guia de tallas ampliada');

    const content = document.createElement('div');
    content.className = 'velae-assistant__lightbox-content';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'velae-assistant__lightbox-close';
    closeButton.setAttribute('aria-label', 'Cerrar guia de tallas');
    closeButton.textContent = '×';

    const image = document.createElement('img');
    image.className = 'velae-assistant__lightbox-image';
    image.src = imageUrl;
    image.alt = altText || 'Guia de tallas VELAE';
    image.width = 1279;
    image.height = 1600;

    const caption = document.createElement('p');
    caption.className = 'velae-assistant__lightbox-caption';
    caption.textContent = 'Toca fuera de la imagen o presiona Escape para cerrar.';

    const closeLightbox = () => {
      document.removeEventListener('keydown', handleKeydown);
      lightbox.remove();
    };

    const handleKeydown = (event) => {
      if (event.key === 'Escape') closeLightbox();
    };

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    closeButton.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', handleKeydown);

    content.append(closeButton, image, caption);
    lightbox.append(content);
    document.body.append(lightbox);
    closeButton.focus();
  };

  const renderSizeGuideAnswer = (query) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'velae-assistant__size-guide';

    const title = document.createElement('strong');
    title.textContent = 'Guia de tallas VELAE';

    const text = document.createElement('p');
    const measurement = getFootLengthCm(query);
    const recommendation = getSizeRecommendationFromCm(measurement);
    const requestedSize = getGuideSizeFromQuery(query);
    const requestedSizeEntry = getGuideEntryFromSize(requestedSize);
    let sizeResult = null;

    if (recommendation?.exact) {
      sizeResult = {
        size: recommendation.size,
        note: `Si tu pie mide ${recommendation.measurement} cm, tu talla recomendada es ${recommendation.size}.`
      };
      text.textContent =
        'Esta recomendacion sale directamente de la guia de tallas VELAE. Toca la imagen para verla mas grande o escribenos por WhatsApp si dudas por la horma.';
    } else if (recommendation?.between) {
      sizeResult = {
        size: recommendation.upperSize,
        note: `${recommendation.measurement} cm queda entre ${recommendation.lowerSize} y ${recommendation.upperSize}. Te recomendamos ${recommendation.upperSize}.`
      };
      text.textContent = `Si dudas por la horma, escribenos por WhatsApp antes de comprar y confirmamos el ajuste segun el modelo.`;
    } else if (recommendation?.belowRange) {
      sizeResult = {
        kicker: 'Talla no disponible',
        size: 'No disponible',
        unavailable: true,
        note: `Por ahora no tenemos tallas disponibles para una medida de ${recommendation.measurement} cm.`
      };
      text.textContent = `La guia VELAE disponible empieza en ${recommendation.nearestCm} cm. Escribenos por WhatsApp y revisamos si hay alguna alternativa especial segun el modelo.`;
    } else if (recommendation?.aboveRange) {
      sizeResult = {
        kicker: 'Talla no disponible',
        size: 'No disponible',
        unavailable: true,
        note: `Por ahora no tenemos tallas disponibles para una medida de ${recommendation.measurement} cm.`
      };
      text.textContent = `La guia VELAE disponible llega hasta ${recommendation.nearestCm} cm. Escribenos por WhatsApp y revisamos si hay alguna alternativa especial segun el modelo.`;
    } else if (requestedSizeEntry) {
      sizeResult = {
        size: requestedSizeEntry.size,
        note: `La talla ${requestedSizeEntry.size} corresponde a un pie de aproximadamente ${requestedSizeEntry.cm} cm.`
      };
      text.textContent =
        'Si estas entre dos medidas o el modelo tiene una horma diferente, escribenos por WhatsApp antes de comprar y confirmamos el ajuste.';
    } else {
      text.textContent =
        'Puedes usar esta guia para medir tu pie en centimetros y elegir tu talla con mas seguridad. Si estas entre dos tallas o dudas por la horma, escribenos por WhatsApp y te ayudamos segun el modelo y el ajuste que prefieres.';
    }

    wrapper.append(title);

    if (sizeResult) {
      const resultCard = document.createElement('div');
      resultCard.className = 'velae-assistant__size-result';
      if (sizeResult.unavailable) resultCard.classList.add('velae-assistant__size-result--unavailable');

      const kicker = document.createElement('span');
      kicker.className = 'velae-assistant__size-result-kicker';
      kicker.textContent = sizeResult.kicker || 'Talla recomendada';

      const size = document.createElement('strong');
      size.className = 'velae-assistant__size-result-size';
      size.textContent = String(sizeResult.size);

      const note = document.createElement('span');
      note.className = 'velae-assistant__size-result-note';
      note.textContent = sizeResult.note;

      resultCard.append(kicker, size, note);
      wrapper.append(resultCard);
    }

    wrapper.append(text);

    if (config.sizeGuideImageUrl) {
      const zoomButton = document.createElement('button');
      zoomButton.type = 'button';
      zoomButton.className = 'velae-assistant__size-guide-zoom';
      zoomButton.setAttribute('aria-label', 'Ampliar guia de tallas');

      const image = document.createElement('img');
      image.className = 'velae-assistant__size-guide-image';
      image.src = config.sizeGuideImageUrl;
      image.alt = config.sizeGuideAlt || 'Guia de tallas VELAE';
      image.loading = 'lazy';
      image.width = 1279;
      image.height = 1600;
      zoomButton.append(image);
      zoomButton.addEventListener('click', () => {
        openSizeGuideLightbox(config.sizeGuideImageUrl, config.sizeGuideAlt);
      });

      const hint = document.createElement('span');
      hint.className = 'velae-assistant__size-guide-hint';
      hint.textContent = 'Toca la imagen para verla mas grande.';

      wrapper.append(zoomButton, hint);
    }

    const actions = document.createElement('span');
    actions.className = 'velae-assistant__context-actions';
    actions.append(
      makeAction(
        'Consultar talla por WhatsApp',
        whatsappUrl(`Hola, necesito ayuda con mi talla en VELAE. ${query ? `Mi consulta es: ${query}` : ''}`),
        'velae-assistant__action--whatsapp'
      )
    );
    wrapper.append(actions);

    addMessage(wrapper);
  };

  const renderPolicyAnswer = (kind) => {
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__results';

    if (kind === 'shipping') {
      text.textContent =
        'Con gusto. Puedes revisar la informacion actualizada de envios aqui. Si quieres confirmar cobertura o tiempo de entrega, te paso con una persona.';
      actions.append(makeAction('Ver politica de envios', config.shippingPolicyUrl));
    } else {
      text.textContent =
        'Claro. La politica publicada tiene los detalles de cambios y devoluciones. Si tu caso es especifico, lo mejor es revisarlo por WhatsApp.';
      actions.append(makeAction('Ver cambios y devoluciones', config.refundPolicyUrl));
    }

    actions.append(
      makeAction(
        'Hablar por WhatsApp',
        whatsappUrl(`Hola, necesito ayuda con ${kind === 'shipping' ? 'envios' : 'cambios o devoluciones'}.`),
        'velae-assistant__action--whatsapp'
      )
    );
    wrapper.append(text, actions);
    addMessage(wrapper);
  };

  const renderHumanHandoff = (query) => {
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    text.textContent =
      'Para ayudarte mejor con eso, te recomiendo hablar con una persona de la tienda. Ya te dejo el mensaje listo.';
    wrapper.append(
      text,
      makeAction(
        'Hablar por WhatsApp',
        whatsappUrl(`Hola, necesito ayuda personalizada. ${query ? `Mi consulta es: ${query}` : ''}`),
        'velae-assistant__action--whatsapp'
      )
    );
    addMessage(wrapper);
  };

  const renderUnsupportedShoeSizeAnswer = (size, query) => {
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__results';

    text.textContent = `Por ahora VELAÉ maneja tallas disponibles de la 35 a la 40. No tenemos talla ${size} disponible en este momento.`;
    actions.append(
      makeButton('Ver talla 40', 'talla 40'),
      makeButton('Ver talla 39', 'talla 39'),
      makeAction(
        'Consultar por WhatsApp',
        whatsappUrl(`Hola, estoy buscando talla ${size} en VELAE. ${query ? `Mi consulta es: ${query}` : ''}`),
        'velae-assistant__action--whatsapp'
      )
    );

    wrapper.append(text, actions);
    addMessage(wrapper);
  };

  const isContactQuery = (text) =>
    matchesAny(text, [
      'contacto',
      'contactar',
      'telefono',
      'teléfono',
      'numero',
      'número',
      'whatsapp',
      'correo',
      'email',
      'e-mail',
      'mail',
      'redes',
      'redes sociales',
      'instagram',
      'facebook',
      'tiktok',
      'tik tok',
      'ubicacion',
      'ubicación',
      'como los contacto',
      'como puedo contactar',
      'donde escribo',
      'hablar con velae',
    ]);

  const renderContactAnswer = (query) => {
    const contact = config.contactInfo || {};
    const wrapper = document.createElement('div');
    const text = document.createElement('p');
    const actions = document.createElement('div');
    actions.className = 'velae-assistant__results';

    text.textContent = `Claro. Puedes contactar a VELAÉ por WhatsApp al ${contact.phone || config.whatsappNumber}, por correo o por redes sociales.`;

    actions.append(
      makeAction(
        'WhatsApp',
        whatsappUrl(`Hola, necesito ayuda con VELAE. ${query ? `Mi consulta es: ${query}` : ''}`),
        'velae-assistant__action--whatsapp'
      )
    );

    if (contact.email) actions.append(makeAction('Correo', `mailto:${contact.email}`));
    if (contact.instagramUrl) actions.append(makeAction('Instagram', contact.instagramUrl));
    if (contact.facebookUrl) actions.append(makeAction('Facebook', contact.facebookUrl));
    if (contact.tiktokUrl) actions.append(makeAction('TikTok', contact.tiktokUrl));

    wrapper.append(text, actions);
    addMessage(wrapper);
  };

  const answer = async (rawQuery) => {
    const query = rawQuery.trim();
    if (!query) return;
    const requestId = ++activeRequest;
    setBusy(false);

    conversationTurns += 1;
    addMessage(query, 'user');
    const text = normalize(query);

    if (matchesAny(text, ['envio', 'entrega', 'delivery', 'costo de envio', 'llega'])) {
      renderPolicyAnswer('shipping');
      return;
    }

    if (matchesAny(text, ['cambio', 'devolucion', 'garantia', 'politica', 'reembolso'])) {
      renderPolicyAnswer('returns');
      return;
    }

    const unsupportedShoeSize = getUnsupportedShoeSize(query);
    if (unsupportedShoeSize) {
      renderUnsupportedShoeSizeAnswer(unsupportedShoeSize, query);
      return;
    }

    if (isSizeGuideQuery(text)) {
      renderSizeGuideAnswer(query);
      return;
    }

    if (isContactQuery(text)) {
      renderContactAnswer(query);
      return;
    }

    if (matchesAny(text, ['persona', 'humano', 'asesor', 'asesora', 'llamar'])) {
      renderHumanHandoff(query);
      return;
    }

    const parsed = getCriteriaFromText(query);
    if (parsed.reset) {
      activeCriteria = { size: '', color: '', type: '', occasion: '', feel: '', budgetMax: '', budgetMin: '', query: '' };
      clearSearchMessages();
      addMessage('Listo, empezamos de nuevo. Dime una talla, ocasion, color o tipo de producto y reviso disponibilidad real.');
      persistState();
      return;
    }

    const criteria = mergeCriteria(query);
    trackEvent('velae_assistant_search', {
      criteria: describeCriteria(criteria),
      turn: conversationTurns,
    });

    if (
      parsed.intents.includes('gift') &&
      !criteria.size &&
      !criteria.color &&
      !criteria.type &&
      !criteria.budgetMax
    ) {
      renderGiftAdvisor(criteria);
      return;
    }

    if (
      parsed.intents.includes('recommendation') &&
      !criteria.size &&
      !criteria.color &&
      !criteria.type &&
      !criteria.occasion &&
      !criteria.feel &&
      !criteria.budgetMax
    ) {
      renderGuidedAdvisor(query, criteria);
      return;
    }

    clearSearchMessages();

    const loading = document.createElement('div');
    loading.className = 'velae-assistant__loading';
    loading.dataset.assistantSearchResult = 'true';
    loading.innerHTML = '<span>Estoy revisando disponibilidad real</span><i></i><i></i><i></i>';
    addMessage(loading, 'bot', false);
    setBusy(true);

    try {
      const result = await searchProducts(criteria);
      if (requestId !== activeRequest) return;
      renderProducts(result, query, criteria);
    } catch (error) {
      if (requestId !== activeRequest) return;
      clearSearchMessages();
      renderHumanHandoff(query);
    } finally {
      if (requestId === activeRequest) setBusy(false);
    }
  };

  toggle.addEventListener('click', () => {
    if (panel.hidden) {
      openPanel();
    } else {
      closePanel();
    }
  });

  close.addEventListener('click', closePanel);

  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const query = input.value;
    input.value = '';
    answer(query);
  });

  chipsContainer?.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-assistant-chip]');
    if (!chip) return;
    trackEvent('velae_assistant_chip_click', { value: chip.dataset.assistantChip });
    answer(chip.dataset.assistantChip);
  });

  messages.addEventListener('click', (event) => {
    const suggestion = event.target.closest('[data-assistant-suggestion]');
    if (!suggestion) return;
    answer(suggestion.dataset.assistantSuggestion);
  });

  restoreState();
  stackWhatsAppButton();
  window.addEventListener('load', syncWhatsAppVisibility);
  window.addEventListener('resize', syncWhatsAppVisibility);
  window.addEventListener('pagehide', persistState);
  window.setTimeout(syncWhatsAppVisibility, 800);
  window.setTimeout(syncWhatsAppVisibility, 2200);
})();
